module.exports = __webpack_public_path__ + "static/spd-bank-9347bfa7e325b23f7388e2747246374b.svg";